import useAuthGuard from "../hooks/useAuthGuard";

export default function AuthGuard({children}) {
  useAuthGuard();

  return children;
}
